<template>
  <div class="dg-wrapper">
    <div class="dg-title mb-0">
      <div class="text-center text-white py-1">
        <span v-if="options.html"  v-html="messageTitle"></span>
        <span v-else>{{ messageTitle }}</span>
      </div>
    </div>

    <div class="dg-body">
      <div v-if="options.html" class="dg-content" v-html="messageBody"></div>
      <div v-else class="dg-content">{{ messageBody }}</div>

      <hr>

      <div class="dg-content-footer text-right pt-0">
        <b-btn class="btn-new btn-light-blue-outline default" @click="handleDismiss" :options="options">Cancel</b-btn>
        <b-btn class="btn-new btn-blue default" @click="handleShare" :options="options">
          <span class="spinner" v-if="isLoading"><i class="fa fa-spinner fa-spin fa-lg fa-fw"></i></span>
          <span v-else>{{ options.proceed }}</span>
        </b-btn>
      </div>
    </div>

    <div v-if="options.remember" class="pb-2 text-center">
      <b-form-checkbox
        v-model="pause"
        @change="val => { }"
        label
      >Disable this prompt for 30 days</b-form-checkbox>
    </div>
  </div>
</template>

<style lang="scss">
.print-dialog {
  .dg-main-content {
    padding: 0;
  }
  .dg-title {
    background-color: #052360;
  }
  .dg-body {
    padding: 15px;
  }
  .spinner {
    padding: 0 13px;
  }
}
</style>

<script>
import DialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js";
import hash from "object-hash";

export default {
  mixins: [DialogMixin],
  data() {
    return {
      pause: false,
      isLoading: false,
    };
  },
  created() {
    if (Cookies.get(hash(this.messageBody))) {
      this.proceed();
    }
  },
  methods: {
    handleShare() {
      if (this.pause) {
        Cookies.set(hash(this.messageBody), 1, { expires: 30 });
      }
      this.proceed();
    },
    handleDismiss() {
      this.cancel();
    }
  },
  components: {}
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Dialogs/Print.vue